export const impressionEventConfiguration = {
  IABImpression: {
    time: 1000,
    viewableThreshold: 0.5
  },
  TrueImpression: {
    time: 1000,
    viewableThreshold: 1
  }
};